import { storeToRefs } from 'pinia'
import { useCommonStore } from 'src/stores/common'

export function usePageMeta() {
  const commonStore = useCommonStore()
  const { businessConfigurations } = storeToRefs(commonStore)

  const titleTemplate = (title) => {
    const name = businessConfigurations.value?.businessName
    if (!name) return title || ''
    return title ? `${name} - ${title}` : name
  }

  return {
    titleTemplate,
  }
}
